<template>
  <div>
    <div class="titleDiv">
      <div class="title">
        <span>字段筛选</span>
      </div>
    </div>
    <div class="other-data">
      <a-row :gutter="10" class="item-label">
        <!--        <a-col :span="8" class="fontWeight">-->
        <!--          <span class="required">参数名称</span>-->
        <!--        </a-col>-->
        <a-col :span="12" class="fontWeight">
          <span class="required">参数字段</span>
        </a-col>
        <a-col :span="12" class="fontWeight">
          <span class="required">参数值</span>
        </a-col>
      </a-row>
      <div class="dataInputDiv">
        <a-row v-for="(item, index) in paramQuery" :key="index" :gutter="12" class="item-data">
          <a-col :span="12">
            <a-select
              v-model="item.fieldId"
              placeholder="请选择参数字段"
              style="width: 100%"
              show-search
              @change="(value) => changeParameterField(value, item)"
              :filter-option="filterOption">
              <a-select-option v-for="(item2, index2) in parameterFieldList" :key="index2" :value="item2.id" :disabled="item2.disabled">
                {{ item2.name }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="12">
            <a-date-picker
              class="endInput"
              v-if="item.valueType === 3"
              :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
              :showToday="false"
              :allowClear="false"
              format="YYYY-MM-DD"
              :placeholder="`请选择${item.msgName}`"
              v-model="item.vaules"
              @change="(value) => changeSpecificListDate(value, index)"
            />
            <a-select
              class="endInput"
              v-else-if="item.valueType === 2"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              v-model="item.vaules"
              :placeholder="`请选择${item.msgName}`">
              <a-select-option
                v-for="(item, index) in item.selectList"
                :key="index"
                :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
            <a-input v-else v-model="item.vaules" class="endInput" :placeholder="item.msgName ? `请输入${item.msgName}` : ''"></a-input>
            <a-icon type="close-square" theme="filled" @click="delParameter(item, index)" class="delIcon"/>
          </a-col>
        </a-row>
      </div>
    </div>
    <a-button block type="dashed" icon="plus" @click="addParameter" class="addBtn_general">添加</a-button>
  </div>
</template>

<script>
import { getTableData } from '@/api/fieldManage'

export default {
  name: 'ParameterScreening',
  data () {
    return {
      // 参数筛选列表
      paramQuery: [],
      // 参数字段列表
      parameterFieldList: []
    }
  },
  created () {
    this.getParameterFieldList()
  },
  methods: {
    // 获取参数字段列表
    getParameterFieldList () {
      const data = {
        paging: false
      }
      getTableData(data).then(async res => {
        if (res.status === 0) {
          for (const item of res.data) {
            item.disabled = item.status === 2
          }
          this.parameterFieldList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 重置parameterFieldList的disabled
    resetFieldDisabled () {
      this.parameterFieldList.forEach(i => {
        i.disabled = i.status === 2
      })
      this.paramQuery.forEach(i => {
        if (i.fieldId) {
          const item = this.parameterFieldList.find(item2 => item2.id === i.fieldId)
          item.disabled = true
        }
      })
    },
    // 参数字段选择
    changeParameterField (value, item) {
      const fieldIndex = this.parameterFieldList.find(item => item.id === value)
      item.valueType = fieldIndex.valueType
      item.value2 = undefined
      item.msgName = fieldIndex.name
      if (fieldIndex.valueType === 2) {
        if (fieldIndex.valueOptions) {
          item.selectList = fieldIndex.valueOptions.split('、')
        }
      }
      this.resetFieldDisabled()
    },
    // 参数字段搜索
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.indexOf(input) >= 0
      )
    },
    // 改变特有参数中的字段名称回调
    changeSpecificListDate (value, index) {
      this.paramQuery[index].vaules = value.format('YYYY-MM-DD')
    },
    // 添加参数
    addParameter () {
      this.paramQuery.push({
        fieldId: '',
        vaules: ''
      })
    },
    // 删除参数
    delParameter (item, index) {
      this.paramQuery.splice(index, 1)
      this.resetFieldDisabled()
    },
    // 重置参数
    reset () {
      this.paramQuery = []
      this.resetFieldDisabled()
    },
    // 获取查询参数并返回给父组件
    getParamQuery () {
      const paramQuery = []
      try {
        this.paramQuery.forEach(item => {
          if (!item.fieldId || !item.vaules) {
            throw new Error('请完善参数信息')
          } else {
            paramQuery.push({
              fieldId: item.fieldId,
              vaules: item.vaules
            })
          }
        })
      } catch (err) {
        this.$message.error(err.message)
        return false
      }
      return paramQuery
    }
  }
}
</script>

<style lang="less" scoped>

.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .title span{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: rgba(8, 64, 159, 1);
  }
}
.item-label{
  margin: 0 0 12px 0 !important;
  background: #F5F5F5;
  .ant-col {
    padding: 10px 8px;
    border-top: 1px solid #DDDDDD;
    border-bottom: 1px solid #DDDDDD;
    border-right: 1px solid #DDDDDD;
  }
  .ant-col:nth-child(1) {
    border-left: 1px solid #DDDDDD;
  }
  .required:before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 12px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }
}
.item-data{
  width: 100%;
  margin-bottom: 12px;
  .endInput {
    width: calc(100% - 40px);
    margin-right: 12px;
  }
  .delIcon {
    font-size: 20px;
    color: red;
  }
}
.addBtn_general {
  width: 100%;
  /deep/.anticon {
    color: #1791FF;
  }
}
</style>
